import React, { Suspense } from 'react';

const withSuspense = (Component) => (props) => (
  <Suspense fallback={<React.Fragment />}>
    <Component {...props} />
  </Suspense>
);

export default withSuspense;
